import { useState } from "react";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function BookConsultationModal({ showModal, setShowModal }) {
	const [formData, setFormData] = useState({
		name: "",
		contact: "",
		concern: "",
	});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const getNextFourthSaturday = () => {
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const getFourthSaturday = (y, m) => {
			let firstDay = new Date(y, m, 1);
			let dayOfWeek = firstDay.getDay();
			let offset = (6 - dayOfWeek + 7) % 7;
			let firstSaturday = 1 + offset;
			return new Date(y, m, firstSaturday + 21);
		};

		let y = today.getFullYear();
		let m = today.getMonth();
		let fourthSat = getFourthSaturday(y, m);
		
		if (today > fourthSat) {
			if (m === 11) {
				return getFourthSaturday(y + 1, 0);
			} else {
				return getFourthSaturday(y, m + 1);
			}
		}
		return fourthSat;
	};

	const isSpecialYogdaan = new Date() < new Date("2026-08-03T00:00:00");
	const nextDate = getNextFourthSaturday();
	const formattedDate = nextDate.toLocaleDateString("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
	});

	const handleSubmit = (e) => {
		e.preventDefault();

		toast
			.promise(
				emailjs.sendForm(
					"service_ixw0cno",
					"template_6ddemqi",
					e.target,
					"OJYJoHKS7rf2lTVtX"
				),
				{
					pending: "Sending request...",
					success: "Consultation request sent successfully!",
					error: "Failed to send email. Try again later.",
				}
			)
			.then(() => {
				setTimeout(() => setShowModal(false), 2000);
			});
	};

	if (!showModal) return null;

	return (
		<div className='fixed inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto'>
			<div className='bg-white p-6 rounded-lg w-full max-w-md my-8'>
				<h3 className='text-xl font-bold mb-4'>Book Yogdaan</h3>

				<form onSubmit={handleSubmit}>
					{/* Hidden Fields for Template Variables */}
					<input type='hidden' name='date' value={isSpecialYogdaan ? "Sunday Aug 2 (4pm to 6pm) - Guru Purnima" : formattedDate} />
					<input type='hidden' name='time' value='N/A' />

					{/* Name Field */}
					<div className='mb-4'>
						<label htmlFor='name' className='block text-gray-700 font-semibold'>
							Name <span className="text-red-500">*</span>
						</label>
						<input
							type='text'
							id='name'
							name='name'
							value={formData.name}
							onChange={handleInputChange}
							className='w-full p-3 border border-gray-300 rounded-md mt-1'
							placeholder='Enter your name'
							required
						/>
					</div>

					{/* Contact Number Field */}
					<div className='mb-4'>
						<label
							htmlFor='contact'
							className='block text-gray-700 font-semibold'
						>
							Contact Number <span className="text-red-500">*</span>
						</label>
						<input
							type='text'
							id='contact'
							name='contact'
							value={formData.contact}
							onChange={handleInputChange}
							className='w-full p-3 border border-gray-300 rounded-md mt-1'
							placeholder='Enter your contact number'
							required
						/>
					</div>

					{/* Concern Field */}
					<div className='mb-4'>
						<label htmlFor='concern' className='block text-gray-700 font-semibold'>
							Your Concern <span className="text-red-500">*</span>
						</label>
						<input
							type='text'
							id='concern'
							name='concern'
							value={formData.concern}
							onChange={handleInputChange}
							className='w-full p-3 border border-gray-300 rounded-md mt-1'
							placeholder='e.g., Not getting job since last 4 months'
							required
						/>
					</div>

					<div className='mb-4 p-3 bg-orange-50 border border-orange-200 rounded-md'>
						<p className='text-sm text-orange-800 text-center'>
							Please WhatsApp your home layout (map) to <strong>9920092640</strong> atleast 24hrs before yogdaan.
						</p>
					</div>

					{/* Date Info */}
					<div className='mb-6 p-3 bg-gray-50 border border-gray-200 rounded-md'>
						{isSpecialYogdaan ? (
							<p className='text-gray-700 font-medium text-center text-lg'>
								Special Yogdaan this Sunday Aug 2 (4pm to 6pm) on ocassion of guru purnima.
							</p>
						) : (
							<p className='text-gray-700 font-medium text-center'>
								Next Yogdaan would be on <br/>
								<span className='font-bold text-lg text-orange-700'>{formattedDate}</span>
							</p>
						)}
					</div>

					{/* Buttons */}
					<div className='flex justify-between items-center'>
						<button
							type='button'
							onClick={() => setShowModal(false)}
							className='text-red-500 font-semibold'
						>
							Close
						</button>
						<button
							type='submit'
							className='px-8 py-3 bg-orange-700 text-white rounded-full shadow-lg hover:bg-orange-800 transition'
						>
							Submit
						</button>
					</div>
				</form>
			</div>
			<ToastContainer position='bottom-center' />
		</div>
	);
}

export default BookConsultationModal;
